import { render, staticRenderFns } from "./imgR.vue?vue&type=template&id=3736fd19"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3736fd19')) {
      api.createRecord('3736fd19', component.options)
    } else {
      api.reload('3736fd19', component.options)
    }
    module.hot.accept("./imgR.vue?vue&type=template&id=3736fd19", function () {
      api.rerender('3736fd19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgR.vue"
export default component.exports